import linkifyStr from 'linkifyjs/string';

import emojiOld from './emoji';
import emojiMore from './emoji-more';

const emoji = emojiOld.concat(emojiMore);

const parserUrl = (text, option = {}) => linkifyStr(text, option);
const replaceToBr = text => text.replace(/\n/gim, '<br />');
const replaceBrToEmpty = (text, { replaceContent }) => text.replace(/\n/gim, replaceContent || '');

const emojiParser = text => {
  if (text) {
    let msg = text;
    emoji.forEach(value => {
      const re = new RegExp(`[\\[\\:]${value.text}[\\:\\]]`, 'g'); // 兼容微信表情
      msg = msg.replace(re, value.native);
    });
    return msg;
  }
  return '';
};

const emojiToEmpty = (text, { replaceContent }) => {
  if (text) {
    const TEST_REGEX = /:([a-z0-9_+-]+)(?:\[((?:[^\]]|\][^:])*\]?)\])?:/g;

    return text.replace(TEST_REGEX, (match, name) => {
      if (emoji.indexOf(name) === -1) {
        return match;
      }
      return replaceContent || '';
    });
  }
  return '';
};

export default {
  parserUrl,
  replaceToBr,
  emojiParser,
  emojiToEmpty,
  replaceBrToEmpty
};
